<div>
  <div class="loader-dots">
    <div class="dot" [style.backgroundColor]="color ?? 'var(--md-sys-color-primary)'"></div>
    <div class="dot" [style.backgroundColor]="color ?? 'var(--md-sys-color-primary)'"></div>
    <div class="dot" [style.backgroundColor]="color ?? 'var(--md-sys-color-primary)'"></div>
    <div class="dot" [style.backgroundColor]="color ?? 'var(--md-sys-color-primary)'"></div>
  </div>
</div>
